import React, { useEffect, useRef, useState } from 'react';
import { HtmlMarker, Popup } from 'azure-maps-control';

const AzureMapMarker = ({
    map,
    position,
    htmlContent,
    options = {},
    popup = null,
    children
}) => {
    const [markerInstance, setMarkerInstance] = useState(null);
    const popupRef = useRef(null);

    useEffect(() => {
        if (!map || !position) return;

        const atlasPosition = [position[1], position[0]];

        const marker = new HtmlMarker({
            position: atlasPosition,
            htmlContent: htmlContent,
            ...options
        });

        if (popup) {
            const popupInstance = new Popup({
                content: typeof popup === 'string' ? `${popup}` : popup,
                position: atlasPosition,
                pixelOffset: [0, -20]
            });
            popupRef.current = popupInstance;
            map.popups.add(popupInstance);

            map.events.add('click', marker, () => {
                popupInstance.open(map);
            });
        }

        map.markers.add(marker);
        setMarkerInstance(marker);

        return () => {
            map.markers.remove(marker);
            setMarkerInstance(null);
            if (popupRef.current) {
                map.popups.remove(popupRef.current);
            }
        };
    }, [map, position, htmlContent, JSON.stringify(options)]);

    return (
        <>
            {map && markerInstance && children && React.Children.map(children, child => {
                if (React.isValidElement(child)) {
                    return React.cloneElement(child, { map, marker: markerInstance });
                }
                return child;
            })}
        </>
    );
};

export default AzureMapMarker;
